module.exports = __webpack_public_path__ + "static/media/home-1.b7888b8e.jpg";